import React from 'react'
import validator from 'validator'
import authHelpers from './auth/AuthHelpers'
import Parse from 'parse'
import { TextField, Grid, Button, Paper, Typography, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
    root: {
        padding: 20,
        marginTop: 100
    },
    button: {
        marginTop: 10,
        padding: 10
    },
    progress: {
        margin: theme.spacing.unit * 2,
    }
});

class LoginContainer extends React.Component {
    constructor() {
        super();
        this.state = {
            username: '',
            password: '',
            loggingIn: false,
            showPassword: false,
            errorMessage: ''
        }
    }

    componentDidMount() {

        if (authHelpers.isAuthenticated()) {
            this.props.history.push("/home");
        }
    }

    handleClickShowPassword = (event) => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    }

    handleMouseDownPassword = event => {
        event.preventDefault();
    }

    handleSubmit = async (event) => {
        try {

            this.setState({ loggingIn: true })

            await Parse.User.logIn(
                this.state.username,
                this.state.password
            )

            this.setState({ loggingIn: false })

            setTimeout(() => {
                this.props.history.push("/home")
            }, 500)

        } catch (error) {

            this.setState({
                loggingIn: false,
                password: '',
                errorMessage: error.message
            })

            setTimeout(() => {
                this.setState({
                    errorMessage: ''
                })
            }, 2500);

        }
    }


    handleInputFieldValueChanged = name => event => {
        this.setState({
            [name]: event.target.value
        })
    }

    render() {

        const { classes } = this.props
        const { username, password, errorMessage, loggingIn } = this.state

        return (
            <Grid container
                alignItems="center"
                justify="center">

                <Paper className={classes.root}>

                    <Typography
                        variant="headline" align="center">
                        Login
                    </Typography>

                    <form autoComplete="off">

                        <TextField
                            id="username"
                            label="Email"
                            className={classes.textField}
                            value={this.state.username}
                            onChange={this.handleInputFieldValueChanged('username')}
                            margin="normal"
                            type="email"
                            fullWidth
                        />

                        <TextField
                            id="password"
                            label="Password"
                            className={classes.textField}
                            value={this.state.password}
                            type="password"
                            onChange={this.handleInputFieldValueChanged('password')}
                            margin="normal"
                            fullWidth
                        />

                        <Button
                            color="primary"
                            variant="raised"
                            className={classes.button}
                            onClick={this.handleSubmit}
                            margin="normal"
                            fullWidth
                            disabled={!validator.isEmail(username) || password.length <= 2 || loggingIn === true}>

                            {
                                loggingIn ? <CircularProgress size={14} color="primary" /> : "Login"
                            }

                        </Button>

                    </form>

                    {
                        errorMessage ?
                            <Typography variant="body1" color="error" gutterBottom style={{ marginTop: 10 }}>
                                Username and/or password are not correct!
                        </Typography> : null
                    }

                </Paper>
            </Grid>


        )
    }
}


export default withStyles(styles)(LoginContainer)


// WEBPACK FOOTER //
// ./src/components/LoginContainer.js